<template>
  <div class="container">
    <!-- 过效期销售 -->
    <div class="title">药品销售信息</div>
    <el-table :data="productList" :cell-style="renderCell">
      <el-table-column prop="documentNo" label="单据号" />
      <el-table-column prop="issuanceDate" label="销售时间" />
      <el-table-column prop="receivingUnit" label="收货单位" />
      <el-table-column prop="productName" label="药品通用名称" />
      <el-table-column prop="approvalNumber" label="药品批准文号" />
      <el-table-column prop="dosageForm" label="剂型" />
      <el-table-column prop="drugSpecifications" label="包装规格" />
      <el-table-column prop="batchNumber" label="生产批号" />
      <el-table-column prop="productDate" label="生产日期" />
      <el-table-column prop="validityTime" label="有效期" />
      <el-table-column prop="number" label="销售量" />
    </el-table>
  </div>
</template>

<script>
export default {
  props: ['productList'],
  methods: {
    renderCell({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 9) {
        return { color: '#FF4C39' };
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.container
  border 1px solid #ccc
  padding 20px
  margin-bottom 20px
  .title
    font-size 16px
    text-align center
    color #000
    font-weight 700
    margin-bottom 20px
</style>
